import servise from '@/router/axios'

export const addDsp = (data) => {
  return servise({
    url: '/Dsp/appDsp',
    method: 'post',
    data
  })
}

export const updateDsp = (data) => {
  return servise({
    url: '/Dsp/updateDsp',
    method: 'PUT',
    data
  })
}

export const upDspStata = (data) => {
  return servise({
    url: '/Dsp/revise/dsp/state',
    method: 'PUT',
    data
  })
}

export const getDspDetailReportList = (params) => {
  return servise({
    url: '/dsp/slot/get/ds/list',
    method: 'get',
    params
  })
}

export const getDspEchartTimeReportList = (params) => {
  return servise({
    url: '/report/echarts/time/list',
    method: 'get',
    params
  })
}

export const getDspList = (params) => {
  return servise({
    url: '/report/dsp/list',
    method: 'get',
    params
  })
}

export const getPercentageBudgetReport = (params) => {
  return servise({
    url: '/report/percentage/budget/list',
    method: 'get',
    params
  })
}
